import { Box, Link, ListItem, Text, UnorderedList } from "@chakra-ui/react"
import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { LabelWithSequenceModel } from "../../../../../api-clients/product-api-v1"
import { apiRoutes, pages, resourceTypes } from "../../../../../common/constants/constants"
import { fetcher } from "../../../../../common/hooks/queries"
import CustomLink from "../../../../shared/CustomLink"

type Props = {
  scopeOfDelivery: LabelWithSequenceModel[]
  areLinksExternal?: boolean
}

const ScopeOfDeliveryColumn = ({ scopeOfDelivery, areLinksExternal }: Props) => {
  const router = useRouter()
  const [linksArray, setLinksArray] = useState<{ key: string; isAvailable: boolean }[] | []>([])

  const productIds = scopeOfDelivery.reduce((accumulator: string[], item: LabelWithSequenceModel) => {
    return item.key.startsWith(resourceTypes.PRODUCT) ? [...accumulator, item.key] : accumulator
  }, [])

  useEffect(() => {
    if (!productIds.length) {
      // Reset state when spare part id in the url changes
      setLinksArray([])
      return
    }

    const fetchData = async () => {
      try {
        const availabilityData = await fetcher(`${apiRoutes.AVAILABILITY}/${pages.PRODUCT}/${productIds}`)

        const linkData = availabilityData?.results
          .map((data: { key: string; assortments: { localization: string }[] }) => {
            const isAvailable = data.assortments.find(
              (assortment: { localization: string }) => assortment.localization === router.locale
            )
            return { key: data.key, isAvailable: !!isAvailable }
          })
          .filter((item: { key: string; isAvailable: boolean }) => item.isAvailable)

        setLinksArray(linkData)
      } catch (e) {
        setLinksArray([])
        console.error(`Error checking product availability: ${e}`)
      }
    }

    fetchData()
  }, [productIds.length])

  return (
    <Box w="100%" pl="3">
      <UnorderedList fontSize="xl" lineHeight="5">
        {scopeOfDelivery.map((item: LabelWithSequenceModel) => {
          const isLink =
            !!linksArray.length &&
            linksArray.find((linkItem: { key: string; isAvailable: boolean }) => linkItem.key === item.key)

          return (
            <ListItem key={item.key} mb="2">
              {isLink ? (
                <CustomLink href={`/${pages.PRODUCT}/${item.key}`}>
                  <Link textDecoration="underline" isExternal={areLinksExternal}>
                    <Text as="span" fontSize="sm">
                      {item.name}
                    </Text>
                  </Link>
                </CustomLink>
              ) : (
                <Text fontSize="sm">{item.name}</Text>
              )}
            </ListItem>
          )
        })}
      </UnorderedList>
    </Box>
  )
}

export default ScopeOfDeliveryColumn
